(() => {
  const observedGalleries = new WeakSet();
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

  const loadPreviewImage = (gallery) => {
    const activeSlide = gallery.querySelector('slideshow-slide[aria-hidden="false"]');
    const previewSlide = activeSlide?.nextElementSibling || gallery.querySelector('slideshow-slide:nth-of-type(2)');
    const previewImage = previewSlide?.querySelector('img[loading="lazy"]');

    if (!previewImage) return;

    previewImage.loading = 'eager';
    previewImage.decoding = 'async';

    if (typeof previewImage.decode === 'function' && !previewImage.complete) {
      previewImage.decode().catch(() => {});
    }
  };

  const observer =
    'IntersectionObserver' in window && canHover.matches
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const gallery = entry.target;
              loadPreviewImage(gallery);
              observer.unobserve(gallery);
            });
          },
          { rootMargin: '200px 0px' },
        )
      : null;

  const prepareGallery = (gallery) => {
    if (!(gallery instanceof HTMLElement) || observedGalleries.has(gallery)) return;

    observedGalleries.add(gallery);
    gallery.addEventListener('pointerdown', () => loadPreviewImage(gallery), { passive: true, once: true });
    gallery.addEventListener('focusin', () => loadPreviewImage(gallery), { once: true });

    if (canHover.matches) {
      gallery.addEventListener('pointerenter', () => loadPreviewImage(gallery), { passive: true, once: true });
    }

    if (observer) {
      observer.observe(gallery);
    }
  };

  const prepareProductCardImages = () => {
    document.querySelectorAll('product-card .card-gallery').forEach(prepareGallery);
  };

  const schedulePreparation = () => {
    prepareProductCardImages();
    requestAnimationFrame(prepareProductCardImages);
    window.setTimeout(prepareProductCardImages, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedulePreparation, { once: true });
  } else {
    schedulePreparation();
  }

  document.addEventListener('shopify:section:load', schedulePreparation);
})();
